var chunkMapping = {
	"205": [
		60205
	],
	"543": [
		50543
	],
	"780": [
		780
	],
	"1271": [
		41271
	],
	"1531": [
		31531
	],
	"1625": [
		71625
	],
	"2122": [
		2122
	],
	"2340": [
		82340
	],
	"2812": [
		2812
	],
	"4222": [
		94222
	],
	"4340": [
		44340
	],
	"4652": [
		4652
	],
	"4917": [
		64917
	],
	"5112": [
		15112
	],
	"5845": [
		45845
	],
	"5962": [
		55962
	],
	"6609": [
		96609
	],
	"7149": [
		57149
	],
	"7303": [
		47303
	],
	"7696": [
		47696
	],
	"7734": [
		37734
	],
	"7745": [
		27745
	],
	"8419": [
		38419
	],
	"8440": [
		48440
	],
	"8556": [
		88556
	],
	"8722": [
		18722
	],
	"8846": [
		28846
	],
	"8939": [
		18939
	],
	"9188": [
		9188
	],
	"9408": [
		19408
	],
	"9418": [
		9418
	],
	"9448": [
		49448
	],
	"9545": [
		39545
	]
};
var idToExternalAndNameMapping = {
	"780": [
		"default",
		"./Dashboard",
		92544
	],
	"2122": [
		"default",
		"./CreateBill",
		46674
	],
	"2812": [
		"default",
		"./Insurance4",
		57093
	],
	"4652": [
		"default",
		"./Seller",
		46674
	],
	"9188": [
		"default",
		"./Buyerinfo",
		24018
	],
	"9418": [
		"default",
		"./Insurance2",
		57093
	],
	"15112": [
		"default",
		"./EFUNDZZ",
		57093
	],
	"18722": [
		"default",
		"./BuyerForm3",
		57093
	],
	"18939": [
		"default",
		"./Buyers",
		24018
	],
	"19408": [
		"default",
		"./Reconciliation",
		24018
	],
	"27745": [
		"default",
		"./BuyerForm8",
		57093
	],
	"28846": [
		"default",
		"./EditBill",
		46674
	],
	"31531": [
		"default",
		"./BuyerForm2",
		57093
	],
	"37734": [
		"default",
		"./BuyerForm7",
		57093
	],
	"38419": [
		"default",
		"./Insurance3",
		57093
	],
	"39545": [
		"default",
		"./ReconciliationBill",
		46674
	],
	"41271": [
		"default",
		"./Collections",
		92544
	],
	"44340": [
		"default",
		"./BuyerForm5",
		57093
	],
	"45845": [
		"default",
		"./Bills",
		46674
	],
	"47303": [
		"default",
		"./Dashboard",
		46674
	],
	"47696": [
		"default",
		"./CreateInvoice",
		24018
	],
	"48440": [
		"default",
		"./Invoice",
		24018
	],
	"49448": [
		"default",
		"./Sellerinfo",
		46674
	],
	"50543": [
		"default",
		"./BuyerForm6",
		57093
	],
	"55962": [
		"default",
		"./Sellerinfo2",
		46674
	],
	"57149": [
		"default",
		"./BuyerForm4",
		57093
	],
	"60205": [
		"default",
		"./EditInvoice",
		92544
	],
	"64917": [
		"default",
		"./Payments",
		92544
	],
	"71625": [
		"default",
		"./Buyer",
		57093
	],
	"82340": [
		"default",
		"./EditInvoice",
		24018
	],
	"88556": [
		"default",
		"./App",
		24018
	],
	"94222": [
		"default",
		"./Buyerinfo2",
		24018
	],
	"96609": [
		"default",
		"./Insurance1",
		57093
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}